import React from "react";
import "./style.css";
import bell from "../../../assets/bell.png";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function EndTestScreen() {

    const [searchParams] = useSearchParams()
    const navigate = useNavigate()

    const title = searchParams.get('title')
    const examId = searchParams.get('examId')
    const subjectId = searchParams.get('subjectId')


    const onViewAnalysis = () => {
        navigate(`/test/analysis?examId=${examId}&title=Analysis&subjectId=${subjectId}`)
    }

    const onGoHome = () => {
        navigate(`/subject/view?subjectId=${subjectId}`);
    }


    return (
        <div className="end_test_wrapper">
            <div className="end_test_container">
                <img src={bell} alt="Bell icon" className="bell_image" />
                <p className="congratulations_text">
                    Congratulations
                </p>
                <p className="end_test_message">
                    You have successfully completed the {title}. You can check the analysis or proceed to take another test.
                </p>

                <button className="go_home_button" onClick={onGoHome}>
                   Take Another Test
                </button>
                <button className="primary_btn view_grading_button" onClick={onViewAnalysis}>
                    View Analysis
                </button>
            </div>
        </div>
    );
}